import { moduleName } from '@edgvr-front/modules/domain';
import { dataModuleEntityId } from './dataModuleEntityId';
import { dataId } from './dataId';
import { dataModuleVORaw } from './dataModuleVORaw';
import { dataStartedAt } from './dataStartedAt';
import { dataVORaw } from './dataVORaw';

export const dataModuleEntityRaw = {
  type: 'object',
  required: ['id', 'moduleName', 'dataId', 'data', 'dataModule', 'startedAt'],
  properties: {
    id: dataModuleEntityId,
    moduleName,
    dataId,
    data: dataVORaw,
    dataModule: dataModuleVORaw,
    startedAt: dataStartedAt,
  },
  additionalProperties: false,
};
